import { MessageDescriptor } from 'react-intl';

import match from './match';
import matchJapan from './match-japan';
import matchLatam from './match-latam';
import parPerfeito from './par-perfeito';
import gEncontros from './g-encontros';
import divinoAmor from './divino-amor';
import singleParentMeet from './single-parent-meet';
import ourTime from './our-time';
import stir from './stir';

export interface Brand {
  branding: Branding;
  seo: SEO;
  components: {
    logo: {
      url?: any;
      light: string;
      dark: string;
    };
  };
}

export interface ThemeForRequest {
  branding: Branding;
  seo: SEO;
}

export interface SEO {
  pageTitle: MessageDescriptor;
  pageDescription: MessageDescriptor;
  pageKeywords: MessageDescriptor;
}

export interface Branding {
  siteName: string;
  favIconName: string;
  name: string;
  facebookUrl?: string;
  instagramUrl?: string;
  twitterUrl?: string;
  successSiteUrl?: string;
  blogUrl?: string;
  securityEmail?: string;
}

const BRANDS: {
  match: Brand;
  matchJapan: Brand;
  matchLatam: Brand;
  parPerfeito: Brand;
  gEncontros: Brand;
  divinoAmor: Brand;
  singleParentMeet: Brand;
  ourTime: Brand;
  stir: Brand;
} = {
  match,
  matchJapan,
  matchLatam,
  parPerfeito,
  gEncontros,
  divinoAmor,
  singleParentMeet,
  ourTime,
  stir
};

export type Brands = typeof BRANDS;
export default BRANDS;
